import React from 'react';
import ReactTooltip from 'react-tooltip';
import { Icon, COLORS } from 'Permafrost/index';
import { StyledTooltip } from './Tooltip.styles';
export const Tooltip = (props) => {
    return (React.createElement(StyledTooltip, { className: props.className, "data-cy": props['data-cy'], id: props.id, 
        // this was done in a hurry, consider refactor on next pass.
        style: { display: props.block ? 'block' : 'inline-block' } },
        props.questionMark && (React.createElement("i", { style: { color: COLORS.curiousBlue }, className: props.questionMarkClassName, "data-tip": props.clickToShow ? 'custom show' : '', "data-event": props.clickToShow ? 'click focus' : '', "data-for": props.for },
            React.createElement(Icon, { name: 'fa-question-circle' }))),
        React.createElement(ReactTooltip, { className: "tool", globalEventOff: props.clickToShow ? 'click' : '', place: props.place || 'top', id: props.for, delayShow: props.delayShow, delayHide: props.delayHide }, props.children)));
};
//# sourceMappingURL=Tooltip.js.map